window.Peloton = function() {
    window.dataLayer = window.dataLayer || [];
    const self = {
        elements: {
            sessionStorage: {
                checkbox: '.vds-checkbox__input'
            }
        },
        urls: {
            landingPage: '/partners-and-rewards/peloton'
        },
        func: {
            init: function () {
                self.func.isTnCCompliant();
            },
            isTnCCompliant: function () {
                if (!sessionStorage.getItem(self.elements.sessionStorage.checkbox)) {
                    self.func.redirectToLandingPage();
                }
            },
            redirectToLandingPage: function () {
                window.Utilities.func.redirect(self.urls.landingPage);
            }
        }
    };
    return {
        init: self.func.init
    };
}();

$('document').ready(function () {
    if ($('#bank-form-journey').data('feature') === 'bankdetails' && $('#bank-form-journey').data('experience-editor') === 'False') {
        window.Peloton.init();
    }
});
